var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirefox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.631 17.4158C40.8045 15.3895 39.1293 13.2019 37.8144 12.5109C38.8847 14.6485 39.5038 16.7925 39.7405 18.3923C39.7405 18.3923 39.7405 18.4036 39.7445 18.4246C37.5935 12.9624 33.9455 10.7595 30.9665 5.96424C30.8153 5.72233 30.6649 5.48043 30.5176 5.2216C30.4345 5.07565 30.3672 4.94341 30.3086 4.81843C30.1852 4.57597 30.0898 4.31971 30.0244 4.05483C30.025 4.04225 30.0209 4.02992 30.013 4.02024C30.0051 4.01055 29.9939 4.0042 29.9817 4.00242C29.97 3.99919 29.9577 3.99919 29.9461 4.00242C29.9429 4.00388 29.94 4.00578 29.9374 4.00806C29.9326 4.00806 29.9279 4.0137 29.9231 4.01532L29.931 4.00483C25.1518 6.85604 23.5304 12.1303 23.3816 14.7694C21.4718 14.9025 19.6457 15.6187 18.1416 16.8248C17.9844 16.6894 17.82 16.5629 17.6492 16.4458C17.2157 14.9003 17.1974 13.2646 17.5961 11.7094C15.6415 12.6165 14.1215 14.0478 13.0164 15.3145H13.0077C12.2532 14.3413 12.3062 11.1312 12.349 10.4612C12.3403 10.4193 11.7869 10.7539 11.7157 10.8047C11.0499 11.2884 10.4276 11.8313 9.85605 12.427C9.20563 13.0987 8.6114 13.8245 8.07957 14.5969C6.85597 16.3631 5.98822 18.3588 5.52646 20.4686C5.51775 20.5106 5.50983 20.5541 5.50112 20.5968C5.4655 20.767 5.33646 21.6209 5.3135 21.8064V21.8491C5.14528 22.7314 5.0405 23.6251 5 24.5229V24.6221C5 35.3238 13.5183 44 24.0252 44C33.4357 44 41.2486 37.0413 42.7789 27.9007C42.8106 27.6531 42.8367 27.4031 42.8652 27.1532C43.2436 23.8295 42.8232 20.3364 41.631 17.4158ZM19.702 32.5847C19.7906 32.6274 19.8745 32.675 19.9656 32.7169L19.9782 32.725C19.8872 32.6798 19.7946 32.6331 19.7027 32.5847H19.702ZM39.746 18.4334V18.4149V18.4359V18.4334Z",
    fill: "url(#paint0_linear_925_49429)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6286 17.405C40.8021 15.3786 39.127 13.191 37.812 12.5C38.8823 14.6376 39.5014 16.7817 39.7381 18.3814V18.4209C41.5336 23.3783 40.5551 28.4195 39.146 31.4997C36.9657 36.2652 31.6877 41.15 23.4251 40.9121C14.5055 40.6541 6.64191 33.9042 5.17337 25.0708C4.90579 23.6766 5.17337 22.9695 5.30796 21.8382C5.14408 22.7098 5.08154 22.9622 5 24.512V24.6112C5 35.3129 13.5183 43.9891 24.0252 43.9891C33.4357 43.9891 41.2486 37.0304 42.7789 27.8898C42.8106 27.6422 42.8367 27.3923 42.8652 27.1423C43.2412 23.8186 42.8209 20.3255 41.6286 17.405V17.405Z",
    fill: "url(#paint1_radial_925_49429)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6286 17.405C40.8021 15.3786 39.127 13.191 37.812 12.5C38.8823 14.6376 39.5014 16.7817 39.7381 18.3814V18.4209C41.5336 23.3783 40.5551 28.4195 39.146 31.4997C36.9657 36.2652 31.6877 41.15 23.4251 40.9121C14.5055 40.6541 6.64191 33.9042 5.17337 25.0708C4.90579 23.6766 5.17337 22.9695 5.30796 21.8382C5.14408 22.7098 5.08154 22.9622 5 24.512V24.6112C5 35.3129 13.5183 43.9891 24.0252 43.9891C33.4357 43.9891 41.2486 37.0304 42.7789 27.8898C42.8106 27.6422 42.8367 27.3923 42.8652 27.1423C43.2412 23.8186 42.8209 20.3255 41.6286 17.405V17.405Z",
    fill: "url(#paint2_radial_925_49429)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3862 19.6881C32.4282 19.7179 32.4654 19.7478 32.5049 19.7776C32.0275 18.9141 31.4326 18.1236 30.738 17.4296C24.8242 11.4062 29.1879 4.3685 29.9233 4.01048L29.9313 4C25.152 6.85121 23.5307 12.1255 23.3818 14.7646C23.6035 14.7493 23.8244 14.7299 24.05 14.7299C27.6164 14.7299 30.7229 16.728 32.3862 19.6881Z",
    fill: "url(#paint3_radial_925_49429)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0624 20.898C24.0315 21.3818 22.3595 23.0429 21.7745 23.0429C16.3643 23.0429 15.4863 26.3763 15.4863 26.3763C15.7238 29.184 17.6444 31.4957 19.9679 32.7189C20.074 32.7746 20.1809 32.8246 20.2846 32.8746C20.4706 32.9552 20.6575 33.0358 20.8435 33.1076C21.6403 33.3938 22.4748 33.5569 23.319 33.5914C32.8016 34.0446 34.6398 22.043 27.7959 18.558C29.5478 18.2476 31.3671 18.966 32.3828 19.6925C30.7203 16.7325 27.613 14.7344 24.0466 14.7344C23.8209 14.7344 23.6001 14.7537 23.3784 14.769C21.47 14.9037 19.6456 15.6208 18.1431 16.8268C18.4337 17.0776 18.7614 17.4114 19.451 18.1033C20.7445 19.4031 24.0553 20.7408 24.0624 20.898V20.898Z",
    fill: "url(#paint4_radial_925_49429)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0624 20.898C24.0315 21.3818 22.3595 23.0429 21.7745 23.0429C16.3643 23.0429 15.4863 26.3763 15.4863 26.3763C15.7238 29.184 17.6444 31.4957 19.9679 32.7189C20.074 32.7746 20.1809 32.8246 20.2846 32.8746C20.4706 32.9552 20.6575 33.0358 20.8435 33.1076C21.6403 33.3938 22.4748 33.5569 23.319 33.5914C32.8016 34.0446 34.6398 22.043 27.7959 18.558C29.5478 18.2476 31.3671 18.966 32.3828 19.6925C30.7203 16.7325 27.613 14.7344 24.0466 14.7344C23.8209 14.7344 23.6001 14.7537 23.3784 14.769C21.47 14.9037 19.6456 15.6208 18.1431 16.8268C18.4337 17.0776 18.7614 17.4114 19.451 18.1033C20.7445 19.4031 24.0553 20.7408 24.0624 20.898V20.898Z",
    fill: "url(#paint5_radial_925_49429)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2565 16.1743C17.4109 16.2759 17.5375 16.3613 17.6523 16.4396C17.2189 14.894 17.2006 13.2583 17.5993 11.7031C15.6447 12.6103 14.1247 14.0415 13.0195 15.3083C13.109 15.3058 15.8687 15.255 17.2565 16.1743V16.1743Z",
    fill: "url(#paint6_radial_925_49429)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.17749 25.0881C6.64602 33.9215 14.5096 40.6713 23.4356 40.9294C31.6982 41.1672 36.973 36.2824 39.1564 31.517C40.5656 28.436 41.5441 23.3956 39.7486 18.4382V18.4011C39.7486 18.4059 39.7486 18.4124 39.7525 18.4333C40.427 22.9222 38.1858 27.2708 34.6819 30.2115C34.6783 30.2198 34.6749 30.2281 34.6716 30.2365C27.8436 35.8994 21.31 33.653 19.9871 32.7362C19.8953 32.691 19.8027 32.6442 19.7108 32.5959C15.7296 30.6607 14.0853 26.9636 14.4376 23.7955C11.077 23.7955 9.93063 20.9072 9.93063 20.9072C9.93063 20.9072 12.9484 18.7156 16.9258 20.6217C20.6094 22.3876 24.0689 20.908 24.0689 20.9072C24.0618 20.75 20.7511 19.4082 19.4599 18.1124C18.7703 17.4206 18.4426 17.0868 18.152 16.836C17.9948 16.7006 17.8304 16.5741 17.6596 16.457C17.5464 16.3764 17.4221 16.2957 17.2638 16.1917C15.876 15.2725 13.1163 15.3233 13.0252 15.3257H13.0165C12.2621 14.3525 12.3151 11.1424 12.3579 10.4724C12.3492 10.4304 11.7958 10.7651 11.7245 10.8159C11.0588 11.2996 10.4365 11.8425 9.86492 12.4382C9.2145 13.1099 8.62027 13.8357 8.08843 14.6081C6.86484 16.3743 5.99708 18.37 5.53532 20.4798C5.52028 20.5169 4.84341 23.527 5.17749 25.0881V25.0881Z",
    fill: "url(#paint7_radial_925_49429)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7379 17.4344C31.4325 18.1284 32.0274 18.9189 32.5049 19.7824C32.6039 19.8581 32.699 19.9389 32.7899 20.0244C37.1029 24.0689 34.8466 29.7947 34.6749 30.206C38.1787 27.2653 40.4199 22.9167 39.7454 18.4278C37.5945 12.9624 33.9465 10.7595 30.9675 5.96424C30.8163 5.72233 30.6659 5.48043 30.5186 5.2216C30.4355 5.07565 30.3682 4.94341 30.3096 4.81843C30.1862 4.57597 30.0908 4.31971 30.0254 4.05483C30.0259 4.04225 30.0219 4.02992 30.014 4.02024C30.0061 4.01055 29.9949 4.0042 29.9827 4.00242C29.971 3.99919 29.9587 3.99919 29.947 4.00242C29.9439 4.00388 29.941 4.00578 29.9383 4.00806C29.9336 4.00806 29.9288 4.0137 29.9241 4.01532C29.1878 4.37333 24.8242 11.411 30.7379 17.4344V17.4344Z",
    fill: "url(#paint8_radial_925_49429)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7863 20.0088C32.6954 19.9234 32.6003 19.8426 32.5013 19.7669C32.4626 19.7371 32.4222 19.7073 32.3826 19.6774C31.3669 18.9517 29.5477 18.2325 27.7957 18.5429C34.6388 22.0279 32.8014 34.0294 23.3189 33.5763C22.4746 33.5418 21.6402 33.3787 20.8434 33.0925C20.6573 33.0215 20.4705 32.9433 20.2844 32.8594C20.1768 32.8094 20.0699 32.7595 19.9678 32.7038L19.9804 32.7119C21.3033 33.6311 27.8369 35.8776 34.665 30.2122C34.665 30.2122 34.6689 30.2018 34.6753 30.1872C34.8447 29.7833 37.1009 24.0575 32.7863 20.0088Z",
    fill: "url(#paint9_radial_925_49429)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4851 26.3709C15.4851 26.3709 16.363 23.0375 21.7732 23.0375C22.3583 23.0375 24.0303 21.3748 24.0611 20.8926C24.092 20.4104 20.6016 22.373 16.918 20.6072C12.9407 18.701 9.92285 20.8926 9.92285 20.8926C9.92285 20.8926 11.0692 23.7809 14.4298 23.7809C14.0775 26.949 15.7218 30.6428 19.703 32.5813C19.7917 32.624 19.8756 32.6716 19.9667 32.7135C17.6431 31.4927 15.7249 29.1785 15.4851 26.3709Z",
    fill: "url(#paint10_radial_925_49429)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.631 17.4158C40.8045 15.3895 39.1293 13.2019 37.8144 12.5109C38.8847 14.6485 39.5038 16.7925 39.7405 18.3923C39.7405 18.3923 39.7405 18.4036 39.7445 18.4246C37.5935 12.9624 33.9455 10.7595 30.9665 5.96424C30.8153 5.72233 30.6649 5.48043 30.5176 5.2216C30.4345 5.07565 30.3672 4.94341 30.3086 4.81843C30.1852 4.57597 30.0898 4.31971 30.0244 4.05483C30.025 4.04225 30.0209 4.02992 30.013 4.02024C30.0051 4.01055 29.9939 4.0042 29.9817 4.00242C29.97 3.99919 29.9577 3.99919 29.9461 4.00242C29.9429 4.00388 29.94 4.00578 29.9374 4.00806C29.9326 4.00806 29.9279 4.0137 29.9231 4.01532L29.931 4.00483C25.1518 6.85604 23.5304 12.1303 23.3816 14.7694C23.6033 14.7541 23.8241 14.7348 24.0498 14.7348C27.6162 14.7348 30.7227 16.7329 32.386 19.6929C31.3703 18.9672 29.551 18.248 27.7991 18.5584C34.6422 22.0434 32.8048 34.045 23.3222 33.5918C22.478 33.5573 21.6435 33.3942 20.8467 33.108C20.6607 33.037 20.4738 32.9588 20.2878 32.875C20.1801 32.825 20.0732 32.775 19.9711 32.7193L19.9838 32.7274C19.892 32.6822 19.7993 32.6355 19.7075 32.5871C19.7962 32.6298 19.8801 32.6774 19.9711 32.7193C17.6428 31.4961 15.7246 29.1819 15.4848 26.3743C15.4848 26.3743 16.3627 23.0409 21.7729 23.0409C22.358 23.0409 24.03 21.3782 24.0608 20.896C24.0537 20.7388 20.743 19.397 19.4518 18.1012C18.7623 17.4094 18.4345 17.0756 18.144 16.8248C17.9868 16.6894 17.8224 16.5629 17.6515 16.4458C17.2181 14.9003 17.1998 13.2646 17.5985 11.7094C15.6439 12.6165 14.1239 14.0478 13.0187 15.3145H13.01C12.2556 14.3413 12.3086 11.1312 12.3514 10.4612C12.3427 10.4193 11.7893 10.7539 11.718 10.8047C11.0523 11.2884 10.43 11.8313 9.85843 12.427C9.208 13.0987 8.61378 13.8245 8.08194 14.5969C6.85835 16.3631 5.99059 18.3588 5.52883 20.4686C5.52012 20.5106 5.51221 20.5541 5.5035 20.5968C5.46787 20.767 5.30637 21.633 5.28421 21.8184C5.28421 21.833 5.28421 21.8047 5.28421 21.8184C5.13597 22.7133 5.04107 23.6164 5 24.5229V24.6221C5 35.3238 13.5183 44 24.0252 44C33.4357 44 41.2486 37.0413 42.7789 27.9007C42.8106 27.6531 42.8367 27.4031 42.8652 27.1532C43.2436 23.8295 42.8232 20.3364 41.631 17.4158ZM39.7437 18.4109V18.4318V18.4109Z",
    fill: "url(#paint11_linear_925_49429)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_925_49429",
    x1: 39.1127,
    y1: 10.1967,
    x2: 6.96962,
    y2: 40.6442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FFE847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FFC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF8B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FF672A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_925_49429",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.6505 8.4288) scale(39.6631 40.3983)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FFBD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFAC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FF9D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF563B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FF3750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F5156C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#EB0878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#E50080"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_925_49429",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.1576 24.9442) scale(39.6631 40.3983)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#960E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#B11927",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#DB293D",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F5334B",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF3750",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_925_49429",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.9434 -0.733202) scale(28.7342 29.2668)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFDC3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FF9D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_925_49429",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.7749 35.5097) scale(18.8851 19.2352)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3A8EE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#5C79F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#9059FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C139E6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_925_49429",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.7311 20.1559) rotate(-14.1446) scale(10.0162 11.959)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#9059FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#8C4FF3",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#7716A8",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#6E008B",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_925_49429",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.658 6.78043) scale(13.5865 13.8384)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FFDB27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFC82A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFA930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FF7E37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FF7139"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_925_49429",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.3401 -1.98393) scale(57.9663 59.0409)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FF5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_925_49429",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.7362 4.46034) rotate(84.3364) scale(43.0271 27.7646)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FFE847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FFC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FF8B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FF672A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_925_49429",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.338 11.9003) scale(36.1884 36.8593)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FF5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_925_49429",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.8923 14.0661) scale(39.6084 40.3427)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FFE141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFAF1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_925_49429",
    x1: 38.7327,
    y1: 10.0306,
    x2: 11.3654,
    y2: 36.9006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FFF44F",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FFF44F",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFF44F",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFF44F",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirefox);
export default __webpack_public_path__ + "static/media/Firefox.29c5929553553c558d651af04f4b464e.svg";
export { ForwardRef as ReactComponent };